import apiClient from "@/services/apiClient";

export default {
    data() {
        return {
            inventoryApiUrl: process.env.VUE_APP_INVENTORY_API_URL
        }
    },
    methods: {
        async getItems(params) {
            const qs = new URLSearchParams(params);

            const {data} = await apiClient.get(`${this.inventoryApiUrl}?${qs}`);

            return data;
        },
        async searchItems(search) {
            let payload = {
                search: search
            }
            const {data} = await apiClient.post(`${this.inventoryApiUrl}/search`, payload);
            return data;
        },
        async getItem(itemId) {
            const {data} = await apiClient.get(`${this.inventoryApiUrl}/${itemId}`);

            return data;
        },
        async updateItem(itemId, data) {
            return await apiClient.put(`${this.inventoryApiUrl}/${itemId}`, data);
        },
        async updateEntireItem(itemId, data) {
            return await apiClient.put(`${this.inventoryApiUrl}/update/${itemId}`, data);
        },
        async createItem(item) {
            const {data} = await apiClient.post(`${this.inventoryApiUrl}/`, item);

            return data;
        },
        async updateItemListingCount(listingId, count) {
            const { data } = await apiClient.put(`${this.inventoryApiUrl}/listing/${listingId}/count/${count}`, {});

            return data;
        },
        async restockListing(listingId, count, consigner, source) {
            let payload = {
                count: count,
                consigner: consigner,
                source: source,
            }
            const { data } = await apiClient.put(`${this.inventoryApiUrl}/listing/${listingId}/restock`, payload);

            return data;
        },
        async getQuantityByListingIds(listingIds) {
            const { data } = await apiClient.post(`${this.inventoryApiUrl}/listings/quantity`, { listingIds });
            
            return data
        },
        async getListingFieldHistory(listingId, field) {
            if (!listingId) return [];
            const { data } = await apiClient.get(`${this.inventoryApiUrl}/history/listing/${listingId}/${field}`);
            return data;
        },
        
        async getItemHistory(id) {
            const {data} = await apiClient.get(`${this.inventoryApiUrl}/history/item/${id}`);

            return data;
        },
        async getItemArchive(itemId) {
            const {data} = await apiClient.get(`${this.inventoryApiUrl}/archive/${itemId}`);

            return data;
        },
        async getCountries() {
            const {data} = await apiClient.get(`${this.inventoryApiUrl}/countries`);

            return data;
        },
        async createCountry(country) {
            const {data} = await apiClient.post(`${this.inventoryApiUrl}/countries`, { name: country });

            return data;
        },
        async getListing(listingId) {
            const {data} = await apiClient.get(`${this.inventoryApiUrl}/listing/${listingId}`);
            return data;
        },
    }
};